import {
  RETRIEVE_CATEGORIES,
  VIEW_CATEGORY, 
  CREATE_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  RESTORE_CATEGORY,
} from "../actions/types";

const initialState = { categories: [], totalCategoryCount: 0 };

const categoryReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_CATEGORIES:
      return {
        categories: payload.rows,
        totalCategoryCount: payload.count,
      };

    case VIEW_CATEGORY:
      return payload;


    case CREATE_CATEGORY:
      return payload;

    case UPDATE_CATEGORY:
      return { ...state, payload };


    case DELETE_CATEGORY:
      return {
        ...state,
        categories: payload.rows,
        totalCategoryCount: payload.count,
      };

    case RESTORE_CATEGORY:
      return {
        ...state,
        categories: payload.rows,
        totalCategoryCount: payload.count,
      };

    default:
      return state;
  }
};

export default categoryReducer;